import { render, staticRenderFns } from "./SubmitIdeas.vue?vue&type=template&id=141f257c"
import script from "./SubmitIdeas.vue?vue&type=script&lang=ts"
export * from "./SubmitIdeas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports